import { CUSTOMER_ACCESS } from '@atlassian/jira-servicedesk-customer-permissions/src/common/types.tsx';
import type { AppState } from '../../../model/app-state/types.tsx';
import {
	type Action,
	FETCH_CHANNELS_INFO,
	FETCH_CHANNELS_INFO_FAILURE,
	SET_CHANNELS_INFO,
	START_FETCHING_CHANNELS_INFO,
} from '../../actions/app-state/index.tsx';

export const initialState = {
	widgetEnabled: false,
	serviceDeskEmail: '',
	isLoading: false,
	portalId: 0,
	chatEnabled: false,
	portalUrl: '',
	customerAccess: CUSTOMER_ACCESS.PUBLIC,
} as const;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: AppState = initialState, action: Action): AppState => {
	switch (action.type) {
		case FETCH_CHANNELS_INFO:
			return {
				...state,
			};
		case START_FETCHING_CHANNELS_INFO:
			return {
				...state,
				isLoading: true,
			};
		case FETCH_CHANNELS_INFO_FAILURE:
			return {
				...state,
				isLoading: false,
			};
		case SET_CHANNELS_INFO:
			return {
				...state,
				isLoading: false,
				widgetEnabled: action.payload.widgetEnabled,
				portalId: action.payload.portalId,
				serviceDeskEmail: action.payload.serviceDeskEmail,
				chatEnabled: action.payload.chatEnabled,
				portalUrl: action.payload.portalUrl,
				customerAccess: action.payload.customerAccess ?? CUSTOMER_ACCESS.PUBLIC,
			};
		default: {
			const _exhaustiveCheck: never = action;
			return { ...state };
		}
	}
};
